import { Btn } from '../primitives/Btn';
import { useIsMobile } from '../../hooks/useIsMobile';
import { BORDER, SURFACE } from '../../tokens';
import { FORM_EMBED_URL, FORM_PAGE_URL } from '../../lib/form';

/**
 * The competitor scan form, embedded inline. Same desktop/mobile split as
 * CtaSection's embed — see src/lib/form.ts for why mobile links out instead.
 */
export function FormEmbed() {
  const isMobile = useIsMobile();

  return isMobile ? (
    <div
      style={{
        border: `1px solid ${BORDER}`,
        borderRadius: 20,
        background: SURFACE,
        padding: 28,
        maxWidth: 700,
        margin: '0 auto',
      }}
    >
      <p style={{ color: 'rgba(245,245,245,0.7)', fontSize: '0.92rem', lineHeight: 1.7, marginBottom: 20 }}>
        Takes about a minute. Opens in a new tab so you do not lose your place here.
      </p>
      <Btn
        href={FORM_PAGE_URL}
        target="_blank"
        style={{ width: '100%', justifyContent: 'center', fontSize: '0.95rem' }}
      >
        Open The Scan Request →
      </Btn>
    </div>
  ) : (
    <div
      style={{
        border: `1px solid ${BORDER}`,
        borderRadius: 20,
        overflow: 'hidden',
        background: '#fff',
        maxWidth: 700,
        margin: '0 auto',
      }}
    >
      <iframe
        src={FORM_EMBED_URL}
        title="Free competitor scan request form"
        allowFullScreen
        loading="lazy"
        style={{
          border: 0,
          display: 'block',
          width: '100%',
          height: 'clamp(520px, 70vh, 760px)',
        }}
      />
    </div>
  );
}
